import { sdkVersionBaseOps } from '@basehub/data/replicache/index'

// exports

export const sdkVersionMutators = {
  // crud
  _getSdkVersion: sdkVersionBaseOps.get,
  _putSdkVersion: sdkVersionBaseOps.put,
  _updateSdkVersion: sdkVersionBaseOps.update,
  _deleteSdkVersion: sdkVersionBaseOps.delete,
  _hasSdkVersion: sdkVersionBaseOps.has,
  _listSdkVersions: sdkVersionBaseOps.list,
}
